import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
import process from 'process';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GA4Provider from './providers/GA4Provider';

window.Buffer = window.Buffer || Buffer;
window.process = window.process || process;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GA4Provider>
      <App />
    </GA4Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
